// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selected[data-v-4464eae3]{background-color:#add8e6}", ""]);
// Exports
module.exports = exports;
